/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @11-09-2019 20:58:43
*/


const userDetailsReducer = (state = {billingName:"",customerCategory:"",customerSubCategory:"",features:[],username:"",email:"",msisdn:"",accounts:[],currentAccount:""}, action) => {
	if (action.type === 'SET_USER_DETAILS') {
		var newState = {};
		Object.assign(newState, state);
		insertDataIntoGivenPath(newState,action.key,action.payload);
		console.log("userDetails newState >>", newState);
		return newState;
	} else {
		return state
	}
}

function insertDataIntoGivenPath(obj, props, newValue) {
	var propsArr = props.split('.');
	var prop = propsArr.splice(0, 1);
	var nextObject = obj[prop];
	if (!propsArr.join('.')) {
		return obj[prop] = newValue;
	} else {
		insertDataIntoGivenPath(nextObject, propsArr.join('.'), newValue);
		return obj;
	}
}

export default userDetailsReducer;
